import React, { useEffect, useMemo, useState } from 'react'
import { Button, Input, Modal, Space, Select, Table, InputNumber } from 'antd';
import { mainAxios } from '../middleware/interceptor';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

const dropDownValue = [
  // { value: 'Bottle', label: 'Bottle' },
  // { value: 'Can', label: 'Can' },
  // { value: 'Case', label: 'Case' },
  // { value: 'Each', label: 'Each' },
  // { value: 'Gallon', label: 'Gallon' },
  // { value: 'Keg (1/2 BBL)', label: 'Keg (1/2 BBL)' },
  // { value: 'Keg (1/4 BBL)', label: 'Keg (1/4 BBL)' },
  // { value: 'Keg (1/6 BBL)', label: 'Keg (1/6 BBL)' },
  // { value: 'Kilogram', label: 'Kilogram' },
  // { value: 'Loaf', label: 'Loaf' },
  // { value: 'Ounce', label: 'Ounce' },
  // { value: 'Pound', label: 'Pound' },
  // { value: 'Quart', label: 'Quart' }
  { "label": "Bag", "value": "Bag" },
  { "label": "Batch", "value": "Batch" },
  { "label": "Bottle", "value": "Bottle" },
  { "label": "Box", "value": "Box" },
  { "label": "Bunch", "value": "Bunch" },
  { "label": "Bushel", "value": "Bushel" },
  { "label": "Can", "value": "Can" },
  { "label": "Case", "value": "Case" },
  { "label": "Container", "value": "Container" },
  { "label": "Count", "value": "Count" },
  { "label": "Crate", "value": "Crate" },
  { "label": "Cup", "value": "Cup" },
  { "label": "Dozen", "value": "Dozen" },
  { "label": "Each", "value": "Each" },
  { "label": "Flat", "value": "Flat" },
  { "label": "Fluid Ounce", "value": "Fluid Ounce" },
  { "label": "Gallon", "value": "Gallon" },
  { "label": "Gram", "value": "Gram" },
  { "label": "Jar", "value": "Jar" },
  { "label": "Keg (1/2BBL) 15.5GAL", "value": "Keg (1/2BBL) 15.5GAL" },
  { "label": "Keg (20L/5.28gal)", "value": "Keg (20L/5.28gal)" },
  { "label": "Keg (30L/7.92gal)", "value": "Keg (30L/7.92gal)" },
  { "label": "Keg (50L/13.2gal)", "value": "Keg (50L/13.2gal)" },
  { "label": "Keg (5L/1.32gal)", "value": "Keg (5L/1.32gal)" },
  { "label": "Keg (1/8BBL) 3.1GAL", "value": "Keg (1/8BBL) 3.1GAL" },
  { "label": "Keg (1/4BBL) 7.75GAL", "value": "Keg (1/4BBL) 7.75GAL" },
  { "label": "Keg (1/6BBL) 5.16GAL", "value": "Keg (1/6BBL) 5.16GAL" },
  { "label": 'Keg (1/2 BBL)', "value": 'Keg (1/2 BBL)' },
  { "label": "Kilogram", "value": "Kilogram" },
  { "label": "Liter", "value": "Liter" },
  { "label": "Loaf", "value": "Loaf" },
  { "label": "Milligram", "value": "Milligram" },
  { "label": "Milliliter", "value": "Milliliter" },
  { "label": "Other", "value": "Other" },
  { "label": "Ounce", "value": "Ounce" },
  { "label": "Pack", "value": "Pack" },
  { "label": "Package", "value": "Package" },
  { "label": "Pail", "value": "Pail" },
  { "label": "Pan", "value": "Pan" },
  { "label": "Pan (1/2)", "value": "Pan (1/2)" },
  { "label": "Pan (1/9)", "value": "Pan (1/9)" },
  { "label": "Pan (1/6)", "value": "Pan (1/6)" },
  { "label": "Pan (1/3)", "value": "Pan (1/3)" },
  { "label": "Piece", "value": "Piece" },
  { "label": "Pint", "value": "Pint" },
  { "label": "Portion", "value": "Portion" },
  { "label": "Pound", "value": "Pound" },
  { "label": "Quart", "value": "Quart" },
  { "label": "Serving", "value": "Serving" },
  { "label": "Sheet", "value": "Sheet" },
  { "label": "Sleeve", "value": "Sleeve" },
  { "label": "Slice", "value": "Slice" },
  { "label": "Tablespoon", "value": "Tablespoon" },
  { "label": "Teaspoon", "value": "Teaspoon" },
  { "label": "Tub", "value": "Tub" }
];

const EditProductModal = ({ visible, setVisible, editData, updateCountSheet }) => {
  // const [quantity, setQuantity] = useState(1);
  const [unit, setUnit] = useState(editData?.subProductUnit || dropDownValue[0].value);
  const [data, setData] = useState([]);
  const [RestID, setRestId] = useState(localStorage.getItem('RestId'));
  const [dropDownOptions, setDropDownOptions] = useState(dropDownValue);

  const pluralizeUnit = (unit) => {
    if (!unit) return '';

    if (unit.endsWith('y')) {
      return unit.slice(0, -1) + 'ies'; // Example: "puppy" → "puppies"
    }

    if (unit.endsWith('s') || unit.endsWith('x') || unit.endsWith('z') || unit.endsWith('ch') || unit.endsWith('sh')) {
      return unit + 'es'; // Example: "box" → "boxes", "bus" → "buses"
    }

    return unit + 's'; // Default pluralization (e.g., "bag" → "bags")
  };

  const pluralUnit = pluralizeUnit(unit);

  const removeIntegersAndSpecialChars = (str) => {
    return (str ?? '').replace(/[^a-zA-Z\s]/g, '').trim();
  };

  const columns = useMemo(() => [
    {
      title: 'Purveyor',
      dataIndex: 'Purveyor',
      key: 'Purveyor',
    },
    {
      title: 'Purveyor Item Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    // {
    //   title: 'Qty',
    //   dataIndex: 'Quantity',
    //   key: 'Quantity',
    //   width: 50,
    // },
    {
      title: 'Unit',
      dataIndex: 'Unit',
      key: 'Unit',
      width: 50,
    },
    {
      title: 'Price / Unit',
      dataIndex: 'Price',
      key: 'Price',
      width: 100,
      onHeaderCell: () => ({
        className: 'left-align-header',
      }),
      onCell: () => ({
        className: 'right-align-body',
      }),
      render: (cell) => (
        <>
          {cell ? `$${Number(cell).toFixed(2)}` : '$0.00'}
        </>
      ),
    },
    {
      title: 'Pack',
      dataIndex: 'Pack',
      key: 'Pack',
      width: 50,
    },
    {
      title: 'Size / Pack',
      dataIndex: 'PackSize',
      key: 'PackSize',
      width: 90,
    },
    {
      title: 'Price / Pack',
      dataIndex: 'PackPrice',
      key: 'PackPrice',
      width: 100,
      onHeaderCell: () => ({
        className: 'left-align-header',
      }),
      onCell: () => ({
        className: 'right-align-body',
      }),
      render: (cell) => (
        <>
          {cell ? `$${Number(cell).toFixed(2)}` : '$0.00'}
        </>
      ),
    },
    {
      title: 'Purchase Date',
      dataIndex: 'Inventory_date',
      key: 'Inventory_date',
      width: 130,
      align: 'center',
      render: (cell) => (
        <>
          {dayjs(cell).format('MM/DD/YYYY')}
        </>
      )
    },
    {
      title: `How Many ${pluralUnit}?`,
      dataIndex: 'UnitCountby',
      key: 'UnitCountby',
      width: 180,
      render: (cell, record) => (
        <InputNumber value={cell} onChange={(e) => { changeUnitQuantity(e, record) }} maxLength={5} />
      )
    },
    {
      title: `${unit} Price`,
      dataIndex: 'changedPrice',
      key: 'changedPrice',
      width: 100,
      onHeaderCell: () => ({
        className: 'left-align-header',
      }),
      onCell: () => ({
        className: 'right-align-body',
      }),
      render: (cell) => (
        <>
          ${cell != '' ? parseFloat(cell).toFixed(2) : '0.00'}
        </>
      ),
    },
  ], [data, unit]);

  const changeUnitQuantity = (value, record) => {
    let count = value;

    let temp = data?.itemsList?.map((list) => (
      list.id === record.id
        ? {
          ...list,
          changedPrice: (!!count && count != '0')
            ? ((Number(list.Price) / count).toFixed(2))
            : '0.00',
          UnitCountby: count
        }
        : list
    ));
    let tempObject = {
      ...data,
      itemsList: temp
    }
    setData(tempObject);
  };

  const saveBaseItemUnits = (params) => {
    let req = {
      "RestId": RestID,
      "CatId": params?.cat_id,
      "CatName": params?.catName,
      "CountSheetId": params?.CountSheetId,
      "subProductId": params?.subProductId,
      "productId": params?.ProductId,
      "baseUnit": unit,
      "ItemsList":
        params?.itemsList?.map((list) => {
          return {
            "id": list?.id,
            "countby": list?.UnitCountby
          }
        })
    };
    // console.log(req)
    mainAxios.post(`api/Inventory/updateBaseUnits`, req).then((res) => {
      if (res?.data?.status === 1) {
        toast.success("Units Updated Successfully");
        updateCountSheet(params?.CountSheetId);
      } else {
        toast.warning("Failed to updated");
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const UpdateArray = (value) => {
    setUnit(value)
    let test = editData?.itemsList?.map((list) => ({ ...list, UnitCountby: 0, changedPrice: '0.00' }
    ))
    let temp = {
      ...editData,
      itemsList: test
    }
    setData(temp);
  };

  useEffect(() => {
    setUnit(editData?.subProductUnit || dropDownValue[0].value);
    let test = editData?.itemsList?.map((list) => (
      !list.UnitCountby ? { ...list, UnitCountby: 1, changedPrice: list.Price } : list
    ))
    let temp = {
      ...editData,
      itemsList: test
    }
    setData(temp);

    const findPack = editData?.itemsList?.map(item =>
      removeIntegersAndSpecialChars(item.PackSize)
    ) || [];

    const prioritized = [...new Set([editData?.subProductUnit, "Pack", ...findPack])];
    const updatedDropDownValue = [
      ...prioritized.map(value => dropDownValue.find(item => item.value === value)).filter(Boolean),
      ...dropDownValue.filter(item => !prioritized.includes(item.value))
    ];

    setDropDownOptions(updatedDropDownValue);
  }, [editData]);

  return (
    <Modal
      title='Edit Product'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      footer={null}
      // footer={[
      //     <Button className='printButton'>
      //         Ok
      //     </Button>
      // ]}
      width={1300}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <div style={{ width: '40%' }}>
            <div>
              <label style={{ marginBottom: '5px' }}>Name</label>
            </div>
            <div>
              <Input style={{ width: '100%' }} value={editData?.SubProduct} readOnly />
            </div>
          </div>

          <div style={{ width: '40%' }}>
            <label style={{ marginBottom: '5px' }}>How do you want to count this product?</label>
            <div style={{}}>
              <div style={{ display: 'flex', gap: '10px' }}>
                {/* <div style={{ width: '20%' }}>
                      <Input
                          type='number'
                          onChange={(value) => { setQuantity(value.target.value); changeQuantity(value.target.value) }}
                          value={quantity}
                      />
                  </div> */}
                <div style={{ width: '40%' }}>
                  <Select
                    showSearch
                    options={dropDownOptions}
                    onChange={(value) => { UpdateArray(value) }}
                    value={unit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-table' style={{ marginTop: 20 }}>
          <Table
            dataSource={data?.itemsList}
            columns={columns}
            pagination={false}
            size={'small'}
            bordered
          />
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'end', marginTop: '20px' }}>
          <Button
            onClick={() => setVisible(false)}
            className='Deactivate-Button'
          >
            <Space>
              Cancel
            </Space>
          </Button>
          <Button
            // disabled
            onClick={() => { saveBaseItemUnits(data) }}
            className='printButton2'
          >
            <Space>
              Save
            </Space>
          </Button>
        </div>
      </div>
    </Modal>
  )
};

export default EditProductModal;
